export const getCurrencySymbol = () => {
  return localStorage.getItem("currencySymbol");
};

export const formatCurrency = (value) => {
  const symbol = getCurrencySymbol();
  const number = Number(value || 0);

  const locale = symbol === "₹" ? "en-IN" : "en-US";

  return `${symbol} ${number.toLocaleString(locale)}`;
};